import styled, { css } from '@eduzz/houston-styles';

export const Item = styled.div`
  display: flex;
  align-items: center;
  transition: color ease-in 0.2s;
  position: relative;
  cursor: pointer;
  padding: 1rem 0.875rem;

  &:hover {
    color: #0d47a1;
    transition: color transform 0.4s ease-in-out;
  }
`;

export const Image = styled.img`
  max-width: 2.5rem;
  max-height: 2.5rem;
  border-radius: 50%;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-left: 1rem;
  flex: 1;
  cursor: pointer;
`;

export const Name = styled.strong`
  display: block;
  width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  font-size: 1rem;

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      width: 12rem;
  `}
`;

export const Email = styled.span`
  margin: 0;
  font-size: 0.875rem;
`;
